export const primaryColor = '#007bff'; // '#4FC3F7';
export const primaryLightColor = '#DAECFF'; // '#F6FCFF';
export const secondaryColor = '#607D8B';
export const accentColor = '#FFEA00';
export const descriptionBgColor = '#F8FAFF';
